import { getTemplateById, TemplateMetadata } from "@/config/templates";

export interface TemplateSeed {
  content: string;
  metadata: TemplateMetadata;
}

const replacePlaceholders = (templateContent: string, valueMap: Record<string, string>): string => {
  return Object.entries(valueMap).reduce((content, [key, value]) => {
    const placeholder = `{${key}}`;
    return content.split(placeholder).join(value ?? "");
  }, templateContent);
};

export const buildTemplateSeed = (templateId: string | null): TemplateSeed => {
  const template = templateId ? getTemplateById(templateId) : undefined;

  if (!template) {
    return { content: "", metadata: {} };
  }

  const defaultValueMap = Object.fromEntries(
    (template.defaultFields || []).map((field) => [field.id, field.defaultValue ?? ""]),
  );

  const contentWithDefaults = replacePlaceholders(template.defaultContent, defaultValueMap)
    // Clean up any placeholders that didn't have default values
    .replace(/\{[^}]+\}/g, "");

  return {
    content: contentWithDefaults.trim(),
    metadata: template.defaultMetadata || {},
  };
};
